import useToggleModal from "hooks/useToggleModal";
import type { ComponentPropsWithoutRef } from "react";
import { Button } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = ComponentPropsWithoutRef<typeof Button> & {
  children: string;
};

const FolderPath = ({ onClick, onMouseUp, children, className }: Props) => {
  // needed for safari
  const { show, open, close } = useToggleModal(false);

  return (
    <Button
      tabIndex={0}
      className={getClasses(
        styles["folder-path"],
        show && styles["folder-path--hover"],
        className,
      )}
      variant={"link"}
      children={children}
      title={children}
      onMouseUp={onMouseUp}
      onMouseEnter={open}
      onMouseLeave={close}
      onClick={onClick}
      draggable={"false"}
    />
  );
};

export default FolderPath;
